var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0169 0L12.2207 2.49632L16.0169 4.99264C18.6781 4.99264 20.8431 7.15776 20.8431 9.81885V12.4816L23.3394 14.9779L25.8358 12.4816V9.81885C25.8358 4.4048 21.431 0 16.0169 0Z",
    fill: "#9EA2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7963 2.49632C14.7963 1.52042 15.2468 0.599179 16.0171 0C10.603 0 6.19824 4.4048 6.19824 9.81885V12.4816L8.69456 14.9779L11.1909 12.4816V9.81885C11.1909 7.15776 13.3559 4.99264 16.0171 4.99264C15.2468 4.39346 14.7963 3.47223 14.7963 2.49632Z",
    fill: "#9EA2E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7267 12.4814H12.5186V31.9999H26.7267C28.128 31.9999 29.264 30.8601 29.264 29.454V15.0273C29.264 13.6213 28.128 12.4814 26.7267 12.4814Z",
    fill: "#FFCE71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0553 29.454V15.0273C15.0553 13.6213 16.1913 12.4814 17.5925 12.4814H5.27354C3.8723 12.4814 2.73633 13.6213 2.73633 15.0273V29.454C2.73633 30.8601 3.8723 31.9999 5.27354 31.9999H17.5925C16.1913 31.9999 15.0553 30.8601 15.0553 29.454Z",
    fill: "#FFCE71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5415 20.9738C19.5415 18.9348 17.8181 17.2983 15.7486 17.4413C13.9753 17.5639 12.5505 19.0201 12.4634 20.7955C12.387 22.3516 13.316 23.7004 14.6571 24.2507L13.9378 25.4966C13.5589 26.1528 14.0325 26.9731 14.7903 26.9731H17.2102C17.9679 26.9731 18.4416 26.1528 18.0627 25.4966L17.3433 24.2507C18.6329 23.7215 19.5415 22.454 19.5415 20.9738Z",
    fill: "#FC8A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.357a079965d1d1f45d4b91b251d6eea8.svg";
export { ForwardRef as ReactComponent };